import cx from 'classnames';
import styles from './LotteryGameRoomBodyWaiting.module.scss';

import { FC, memo, useContext } from 'react';

import { AppContext } from '@app/providers';
import { Typography } from '@shared/Typography';
import { Avatar } from '@shared/Avatar';
import { UserDto } from '@app/store/api/tunedRestApi';
import { LotteryInfoGameRoomState } from '@features/LotteryGame/store';
import { useTranslation } from 'react-i18next';

interface LotteryGameRoomBodyWaitingProps {
  user?: UserDto;
  avatar?: string;
  lottery: LotteryInfoGameRoomState;
}

export const LotteryGameRoomBodyWaiting: FC<LotteryGameRoomBodyWaitingProps> = ({
  user,
  avatar,
  lottery,
}) => {
  const { isTelegramBot } = useContext(AppContext);
  const { t } = useTranslation('mainPage');

  return (
    <div
      className={cx(styles.lgrbwContainer, {
        [styles.lgrbwContainerSite]: !isTelegramBot,
      })}
    >
      <div className={styles.lgrbwHead}>
        <div className={styles.lgrbwHeadItem}>
          <Typography component="h3" textTransform={'uppercase'}>
            {t('players')}:
          </Typography>

          <Typography component="h3">{lottery.players.length}/10</Typography>
        </div>

        <div className={styles.lgrbwDivider} />

        <div className={styles.lgrbwHeadItem}>
          <Typography component="h3" textTransform={'uppercase'}>
            {t('bet')}:
          </Typography>

          <Typography component="h3">{'$ ' + lottery.gameRoom.bet}</Typography>
        </div>
      </div>

      <div className={cx(styles.lgrbwList, { [styles.lgrbwListSite]: !isTelegramBot })}>
        {lottery.players.map((playerNumber, index) => {
          const iAmPlayer = user && user.displayNumber === playerNumber;

          return (
            <LotteryGamePlayer
              key={playerNumber}
              playerNumber={playerNumber}
              index={index}
              isCurrentUser={iAmPlayer ?? false}
              avatar={avatar}
              username={user?.username}
            />
          );
        })}
      </div>
    </div>
  );
};

interface LotteryGamePlayerProps {
  index: number;
  playerNumber: number;
  isCurrentUser: boolean;
  avatar?: string;
  username?: string;
}

export const LotteryGamePlayer: React.FC<LotteryGamePlayerProps> = memo((props) => {
  const { playerNumber, index, isCurrentUser, avatar, username } = props;

  return (
    <div
      className={cx(styles.lgrbwListItem, {
        [styles.lgrbwListOddItem]: index % 2 === 0,
      })}
    >
      <Typography component="h3" className={styles.playerNumber}>
        {index + 1}
      </Typography>

      <div className={styles.playerInfo}>
        <Avatar small src={isCurrentUser && avatar ? avatar : ''} />
        <Typography
          component="h3"
          className={isCurrentUser ? styles.lgrbwMyName : undefined}
        >
          {isCurrentUser && username ? username : `#${playerNumber}`}
        </Typography>
      </div>
    </div>
  );
});
